import { getDXPMockEnvironmentRootPath } from '@/utils/envUtils'
import Response from '@/modules/core/models/Response'

export interface RequestConfig<D = any> {
  url?: string
  method?: string
  baseURL?: string
  headers?: any
  params?: any
  data?: D
}

const HEADERS = {
  'Content-Type': 'application/json'
}

function clearCache(path: string): string {
  const timeStamp = new Date().getTime()
  const prefix = path.includes('?') ? '&' : '?'
  return `${path}${prefix}timeStamp=${timeStamp}`
}

export default class DXPMockService {
  static async fetchCall({ url, method }: RequestConfig): Promise<Response> {
    try {
      const config = {
        method,
        headers: HEADERS
      }
      const path = `${getDXPMockEnvironmentRootPath()}${url}`
      const responseJSON = await fetch(clearCache(path), config)
      const response = await responseJSON.json()

      return new Response({ data: response })
    } catch (error: any) {
      const aborted = error.name === 'AbortError'

      const message = 'Ha ocurrido un error en la llamada al DXP Mock'
      return new Response({ data: message, error: true, aborted })
    }
  }

  static async get(url: string, config?: RequestConfig) {
    return this.fetchCall({ ...config, url, method: 'GET' })
  }

  static async post(url: string, data: unknown, config?: RequestConfig) {
    return this.fetchCall({ ...config, url, method: 'GET' }) //Post to get
  }
}
